export const WORKFLOW_USER_PREFERENCES_KEY = 'ADMIN_WORKFLOW_USER_PREFERENCES';

export const COLLAPSE_TRANSITION_LABELS_PREFERENCE_KEY =
	'jira.user.workflow.editor.collapsed.transitions';
export const TEXT_VIEW_PREFERENCE_KEY = 'jira.user.workflow.editor.list-view';
export const DEFAULT_EDITOR_PREFERENCE_KEY = 'jira.user.workflow.editor.global.scope.enrolment';
export const CHANGEBOARDING_DISMISSED_PREFERENCE_KEY =
	'jira.user.workflow.editor.changeboarding-dismissed';
export const NEW_EDITOR_DEFAULT_FOR_ALL_WARNING_SEEN_PREFERENCE_KEY =
	'jira.user.workflow.editor.new-editor-default-for-all-warning-seen';
